import React, { useEffect, useState, useRef } from 'react';

import Swal from 'sweetalert2';
import { Header, Button } from '../components'
import {
  AgentName, dropdownDataColumn, dropdownDataReviewPeriodStart, dropdownDataReviewPeriodEnd,
  dropdownDataKorAnalyzer, dropdownDataColumnSpellChecked
} from '../data/dummy';
import { useStateContext } from '../contexts/ContextProvider';
import AgentComment from '../components/AgentComment';
import Dropdown from '../components/Dropdown';
import DataPreview from '../components/DataPreview';
import Progressbar from '../components/Charts/Progressbar';

import ModelPerformance from '../components/ModelPerformance';
import ModelParameterList from '../components/ModelParameterList';
import TransferLearningDataset from '../components/TransferLearningDataset';
import StopwordManager from '../components/StopwordManager';
import NnpManager from '../components/NnpManager';
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import S3FileRequest from './S3FileRequest';

const DataPreprocess = () => {
  const S3FileRequestRef = useRef();

  const [stopwords, setStopwords] = useState([]);
  const [nnpwords, setNnpwords] = useState([]);
  const [userId, setUserId] = useState('');
  const [previewType, setPreviewType] = useState("raw");
  const navigate = useNavigate();


  const [isRequestSent, setIsRequestSent] = useState(false); // 요청 제어를 위한 상태 추가


  const { currentColor, currentMode } = useStateContext();
  const morphemeList = ['일반명사(NNG)', '고유명사(NNP)', '단위명사(NNBC)',
    '동사(VV)', '형용사(VA)', '보조용언(VX)', '긍정지정사(VCP)', '부정지정사(VCN)'];

  const [inputWordNum, setInputWordNum] = useState(50);

  const [isPreprocessingStarted, setIsPreprocessingStarted] = useState(false);
  const [isPreprocessingCompleted, setIsPreprocessingCompleted] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);

  const [progress, setProgress] = useState(0);
  const [progressStatus, setProgressStatus] = useState("전처리 및 시각화가 완료되면 결과를 확인하실 수 있어요 :)");
  const [selectedValueSpellCheckCol, setSelectedValueSpellCheckCol] = useState('');
  const [selectedValueVisualizingCol, setSelectedValueVisualizingCol] = useState('');
  const [isSpellChecked, setIsSpellChecked] = useState(false);
  const [spellCheckColumn, setSpellCheckColumn] = useState('');
  const [visualizingColumn, setVisualizingColumn] = useState('');
  const [analyzerType, setAnalyzerType] = useState('');
  const [selectedValueAnalyzerType, setSelectedValueAnalyzerType] = useState('');
  const [isCheckedOneWordRemove, setIsCheckedOneWordRemove] = useState(true);
  let dropdownVisualizingColumn = dropdownDataColumn;

  const [unixTime, setUnixTime] = useState('');

  const handleKeyPress = (event) => {
    // ysjeon | input 변수 정의 필요 - event.target.value 사용
    if (event.key === "Enter" && event.target.value.trim() !== "") {
      const normalizedInput = event.target.value.trim(); // 입력값의 앞뒤 공백 제거
      setInputWordNum(normalizedInput); // 입력창 초기화
    }
  };

  const handleSpellCheckColumn = (selectedValueSpellCheckCol) => {
    setSpellCheckColumn(selectedValueSpellCheckCol); // Dropdown 선택 값 업데이트
  }

  const handleVisualizingColumn = (selectedValueVisualizingCol) => {
    setVisualizingColumn(selectedValueVisualizingCol); // Dropdown 선택 값 업데이트
  }

  const handleAnalyzerType = (selectedValueAnalyzerType) => {
    setAnalyzerType(selectedValueAnalyzerType); // Dropdown 선택 값 업데이트
  }

  const handleSpellCheck = () =>{
    if (spellCheckColumn){
      
      Swal.fire({
        title: '맞춤법 교정 시작',
        html: "새로고침하지 마시고 잠시만 기다려주세요.<br/>최대 30초까지 소요될 수 있어요 :)",
        icon: 'info',
        timer: 7000,
        allowOutsideClick: false, // 팝업 밖을 클릭해도 닫히지 않음
        allowEscapeKey: false,    // ESC 키로 닫을 수 없게 설정
        allowEnterKey: false,     // 엔터 키로 닫을 수 없게 설정
        timerProgressBar: true,   // 타이머 진행 상황 표시
        didOpen: () => {
            Swal.showLoading();     // 팝업에 로딩 애니메이션 표시
        },
        willClose: () => {
          Swal.fire({
            title: `맞춤법 교정 완료`,
            icon: 'success',
            confirmButtonText: '확인',
            confirmButtonColor: currentColor,
          })
          setIsSpellChecked(true);
          setPreviewType("spellchecked")
          dropdownVisualizingColumn = dropdownDataColumnSpellChecked;
        }
    })
    } else {
      Swal.fire({
        title: '컬럼을 먼저 선택해 주세요',
        icon: 'warning',
        confirmButtonText: '확인',
        confirmButtonColor: currentColor,
        didOpen: () => {
          Swal.hideLoading(); // 혹시 이전에 로딩이 있었다면 명시적으로 로딩 숨기기
      }
      });
    }
    
  }

  const handleProgressBar = () => {
    if (!visualizingColumn){
      Swal.fire({
        html: `상단에서 전처리할 컬럼을 먼저 선택해 주세요`,
        icon: 'warning',
        confirmButtonText: '확인',
        confirmButtonColor: currentColor,
        didOpen: () => {
          Swal.hideLoading(); // 혹시 이전에 로딩이 있었다면 명시적으로 로딩 숨기기
      }
      });
      return;
    }

    if (!analyzerType){
      Swal.fire({
        html: `형태소 분석기를 먼저 선택해 주세요`,
        icon: 'warning',
        confirmButtonText: '확인',
        confirmButtonColor: currentColor,
        didOpen: () => {
          Swal.hideLoading(); // 혹시 이전에 로딩이 있었다면 명시적으로 로딩 숨기기
      }
      });
      return;
    }


    if (inputWordNum <= 0) {
      Swal.fire({
        title: '시각화할 단어 개수 선택 필요',
        html : `최소 1 이상의 숫자를 입력해 주세요.<br/>50 이상의 숫자 입력을 권장해 드려요`,
        icon: 'warning',
        confirmButtonText: '확인',
        confirmButtonColor: currentColor,
      });
      return;
    }
    Swal.fire({
      title: '전처리/시각화 시작',
      html: "새로고침하지 마시고 잠시만 기다려주세요.<br/>최대 30초까지 소요될 수 있어요 :)",
      icon: 'info',
      confirmButtonText: '확인',
      confirmButtonColor: currentColor,
      didOpen: () => {
        Swal.hideLoading(); // 혹시 이전에 로딩이 있었다면 명시적으로 로딩 숨기기
    }
    });

    setIsPreprocessingCompleted(false);
    setIsPreprocessingStarted(true);
    setShowSpinner(true);

    return;
  };

  const handlePreprocessReset = () => {
    Swal.fire({
      title: '전처리를 리셋하였습니다.',
      icon: 'info',
      confirmButtonText: '확인',
      confirmButtonColor: currentColor,

    });
    setIsPreprocessingCompleted(true);
    setIsPreprocessingStarted(false);
    setShowSpinner(false);
    setProgress(0);
    setProgressStatus("전처리 및 시각화가 완료되면 결과를 확인하실 수 있어요 :)");
    return;
  };


  // 체크박스 상태 변경 핸들러
  const handleOneWordRemoveCheckboxChange = (event) => {
    setIsCheckedOneWordRemove(event.target.checked);
  };


  useEffect(() => {
    if (isPreprocessingStarted) {
      const interval = setInterval(() => {
        setProgress(prev => {
          // const nextProgress = prev + 5;
          // 1에서 6까지의 랜덤한 값으로 progress 증가
          const randomIncrement = Math.floor(Math.random() * 6) + 1;
          const nextProgress = prev + randomIncrement;
          if (nextProgress < 12) {
            setProgressStatus("선택한 품사 기준 토큰화 진행 중...");
          } else if (12 <= nextProgress && nextProgress < 30) {
            setProgressStatus("자주 등장한 키워드순 집계 중...");
          } else if (30 <= nextProgress && nextProgress < 70) {
            setProgressStatus("워드클라우드 시각화 진행 중 ...");
          } else if (70 <= nextProgress && nextProgress < 90) {
            setProgressStatus("동시출현 키워드 행렬 계산 중...");
          } else if (90 <= nextProgress && nextProgress < 100) {
            setProgressStatus("키워드 네트워크 시각화 진행 중 ...");
          } else if (100 <= nextProgress) {
            setProgressStatus("전처리 및 시각화 완료!");
          }


          if (nextProgress >= 100) {
            setIsPreprocessingStarted(false);
            setShowSpinner(false);
            setIsPreprocessingCompleted(true);
            S3FileRequestRef.current.handleDownloadCSV();
            Swal.fire({
              title: `전처리 및 시각화를 완료했습니다.`,
              html : '좌측 메뉴바에서 워드클라우드부터 키워드 빈도,<br>네트워크 시각화까지 결과를 확인해 보세요',
              icon: 'success',
              confirmButtonText: '확인',
              confirmButtonColor: currentColor,
            });
            return 100;
          } else {
            return nextProgress;
          }


          // return nextProgress >= 100 ? 100 : nextProgress; // 100%를 초과하지 않도록 설정
        });
      }, 1500); // 1.5초마다 업데이트

      return () => clearInterval(interval);
    }

    const storedUserID = localStorage.getItem('userId');
    setUserId(storedUserID || '');
    console.log(`storedUserID: ${storedUserID}`);

    
  }, [previewType, isPreprocessingStarted]);


  const handleLambdaRequest = async () => {
    // const unixtimeValue = Math.floor(Date.now() / 1000);
    const unixtimeValue = 1732504766;
    console.log(`unixtimeValue: ${unixtimeValue}`);
    setUnixTime(unixtimeValue);
    localStorage.setItem('unixTime', unixtimeValue);
    console.log("handleLambdaRequest를 시작합니다.");

    // if (isRequestSent) return;
    // setIsRequestSent(true); // 요청 보냄 상태로 설정

    let requestData;

    try {
      requestData = {
          unix_time: unixtimeValue,
          profileID: "00000000000",   // 사용자 아이디
          file_raw: "classified_toss_6_spellchecked.csv",  // 확장자 붙은 파일명
          column_name: "ReviewContent", // 분석하려는 문자열 컬럼
          stopword: ["QR코드"],  // 사용자가 입력한 불용어 문자열 
          proper_noun: ["인증"],        // 사용자가 입력한 고유명사 문자열 
          analyzer_code: "Mecab",
          max_words: inputWordNum,
          morpheme_code: ["NNG", "NNP", "NNB", "VV", "VA", "VX", "VCP", "VCN"],
          remove_oneLetter: true,
      };

      console.log("response1 시작");
      const response1 = await axios.post(
        "https://yr22o9vink.execute-api.ap-northeast-2.amazonaws.com/b2b_word_freq/b2b_word_freq",
        requestData,
        {
        headers: {
          "Content-Type": "application/json",
        },
      }
      ).then((res)=>{
        const responseBody1 = JSON.parse(res.data.body); // `body`를 JSON으로 파싱
        console.log("Lambda 응답:", responseBody1);
      });
      
      requestData = {
        unix_time: unixTime,
        profile_id: "00000000000",   // 사용자 아이디
        file_raw: "classified_toss_6_spellchecked.csv",  // 확장자 붙은 파일명
        column_name: "ReviewContent", // 분석하려는 문자열 컬럼
        stopword_list: ["QR코드"],  // 사용자가 입력한 불용어 문자열 
        noun_list: ["인증"],        // 사용자가 입력한 고유명사 문자열 
        analyzer_code: "Mecab",
        max_words: inputWordNum,
        morpheme_code: ["NNG", "NNP", "NNB", "VV", "VA", "VX", "VCP", "VCN"],
        rm_oneLetter: true,
      };

      console.log("response2 시작");
      const response2 = await axios.post(
        "https://9sbv18swma.execute-api.ap-northeast-2.amazonaws.com/b2b/b2b_network",
        requestData,
        {
        headers: {
          "Content-Type": "application/json",
        },
      }
      ).then((res)=>{
        const responseBody2 = JSON.parse(res.data.body); // `body`를 JSON으로 파싱
        console.log("Lambda 응답:", responseBody2);
      });

      // 요청 데이터 출력
      console.log("요청 데이터:", requestData);

    } catch (error) {
      if (error.response) {
        console.error("응답 오류:", error.response.status, error.response.data);
      } else if (error.request) {
        console.error("요청 실패:", error.request);
      } else {
        console.error("설정 오류:", error.message);
      }
      // setIsRequestSent(true); // 실패 시 재시도 가능하도록 false 설정
    }
  };

  return (

    <div className="m-2 md:m-10 mt-0 p-2 md:p-10 bg-white rounded-3xl">

      <Header category="데이터 시각화" title="데이터 전처리" />
      {/* 상단 컴포넌트 그룹 */}
      <div className="bg-white p-8 rounded-3xl shadow-lg mb-12">
      <Header title="맞춤법 교정하기" />
        <div className="flex gap-5">
          <AgentComment title={AgentName}
            comment={"데이터 전처리 단계에서 먼저 맞춤법 교정으로 리뷰의 정확성을 높여 분석 오류를 줄이세요. 형태소 분석기 선택은 분석 목적에 맞게 결정하는 것이 중요합니다(예: 감정 분석은 감성 단어 추출 중심). 불용어 제거는 -그리고-, -그러나- 같은 분석에 불필요한 단어를 걸러내어 노이즈를 줄입니다. 고유명사 제거는 특정 브랜드나 인물 이름 등 불필요한 요소를 제거해 데이터의 일반화를 돕습니다. 각 단계를 분석 목적에 맞춰 유연하게 적용하세요."}></AgentComment>
        </div>
        <br /><br />
        <div className="flex gap-3 items-center">
          <p className="text-s font-semibold">조회기간 선택</p>
          <p className="text-s">시작일</p>
          <Dropdown currentMode={currentMode} dropdownData={dropdownDataReviewPeriodStart} />

          <p className="text-s">종료일</p>
          <Dropdown currentMode={currentMode} dropdownData={dropdownDataReviewPeriodEnd} />

          <p className="text-s font-semibold">맞춤법 교정 컬럼 선택</p>
          <Dropdown currentMode={currentMode} 
                      dropdownData={dropdownDataColumn}
                      selectedValue={selectedValueSpellCheckCol} // 선택된 값 전달
                      onChange={handleSpellCheckColumn} // 선택 값 변경 핸들러

                       />

            <Button
              color="white"
              bgColor={currentColor}
              text="맞춤법 교정하기"
              borderRadius="10px"
              onClick={() => handleSpellCheck()}
            />
          <p className="text-s font-semibold">전처리 컬럼 선택</p>
          {isSpellChecked 
            ?
            <Dropdown currentMode={currentMode}
                      dropdownData={dropdownDataColumnSpellChecked}
                      selectedValue={dropdownDataColumnSpellChecked} // 선택된 값 전달
                      onChange={handleVisualizingColumn} // 선택 값 변경 핸들러
                       />
             :
             <Dropdown currentMode={currentMode}
             dropdownData={dropdownDataColumn}
             selectedValue={dropdownDataColumnSpellChecked} // 선택된 값 전달
             onChange={handleVisualizingColumn} // 선택 값 변경 핸들러
              />

             }
        </div>
        {isSpellChecked
        ?
        <DataPreview previewType={"spellchecked"}></DataPreview>
        :
        <DataPreview previewType={"raw"}></DataPreview>
        }
      </div>
      <br/><br/>

      <Header title="형태소 분석기" />
      {/* 컴포넌트 그룹 */}
      <div className="bg-white p-8 rounded-3xl shadow-lg">
        <AgentComment title={AgentName} comment={"형태소 분석기는 데이터 특성과 분석 목표에 맞게 선택하는 게 좋아요. Mecab은 처리 속도가 빨라 대용량 데이터에 적합하고, 일반명사와 고유명사 추출에 강해요. Okt는 형태소 태깅이 세밀해서 감정 분석이나 동사/형용사 중심 작업에 유리해요. Hananum과 Kkma는 문법 구조 분석에 강점이 있어 문맥 기반 분석에 적합하고, Komoran은 비교적 다양한 품사를 균형 있게 추출할 수 있어요. 분석 목표와 필요한 품사에 맞춰 테스트해보고 선택하면 돼요."}></AgentComment>
        <br />
        <div className="flex gap-3">
          <p className="text-xl font-semibold">형태소분석기 선택</p>
          <Dropdown currentMode={currentMode} dropdownData={dropdownDataKorAnalyzer}
                    selectedValue={selectedValueAnalyzerType} // 선택된 값 전달
                    onChange={handleAnalyzerType} // 선택 값 변경 핸들러
          />
          <p className="text-xl font-semibold">1글자 단어 제거여부</p>
          <label key={'one-char-word'} style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
              <input
                type="checkbox"
                checked={isCheckedOneWordRemove}
                onChange={handleOneWordRemoveCheckboxChange}
                style={{ marginRight: '8px' }}
              />
              제거(ex. 물, 짱, 킹 등)
            </label>
        </div>
        <br />
        <div className="flex gap-5">
          <p className="text-xl font-semibold">시각화 품사 선택</p>
          {morphemeList.map((morphemeName, index) => (
            <label key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
              <input
                type="checkbox"
                checked={true}
                onChange={null}
                style={{ marginRight: '8px' }}
              />
              {morphemeName}
            </label>
          ))}
        </div>
      </div>
      <br/><br/><br/><br/>


      <Header title="고유명사 불용어 등록" />
      {/* 불용어&고유명사 리스트 */}
      <AgentComment title={AgentName} comment={"제거할 단어 등록 기능은 분석에 불필요한 단어를 걸러내 데이터의 노이즈를 줄이는 데 유용해요. 예를 들어, -음-, -이런-, -저런- 같은 의미 없는 단어나 반복되는 단어를 등록하면 더 깔끔한 분석이 가능해요. 고유명사 등록 기능은 특정 브랜드나 지명, 사람 이름처럼 분석에 필요하지만 기본 사전에 없는 단어를 추가해 정확성을 높이는 데 도움을 줘요. 예를 들어, -토스-, -카카오- 같은 고유명사를 등록하면 분석 결과에서 의미 있는 패턴을 더 잘 포착할 수 있어요."}></AgentComment>


      <div className="bg-white p-8 rounded-3xl shadow-lg w-full h-full">
        <br />
        <div className="flex gap-20 h-full w-full">

          <div className="flex-1 h-full">
            <StopwordManager stopwords={stopwords} setStopwords={setStopwords}/>
            {/* <StopwordManager /> */}
          </div>
          <div className="flex-1 h-full">
            <NnpManager nnpwords={nnpwords} setNnpwords={setNnpwords}/>
            {/* <NnpManager /> */}
          </div>
        </div>
      </div>
      <br/><br/>
 
      {/* 컴포넌트 그룹 */}
      <div className="bg-white p-8 rounded-3xl shadow-lg">
        {/* <div className="flex justify-end"> */}
        <div className="flex items-center gap-3">
          <p className="text-xl font-semibold">시각화할 단어 개수 선택</p>
          <input
            type="number" // 숫자만 입력 가능
            value={inputWordNum}
            onChange={(e) => setInputWordNum(e.target.value)}
            onKeyUp={handleKeyPress} // onKeyDown 대신 onKeyUp 사용
            placeholder="숫자만 입력해 주세요"
            style={{
              width: "80px",
              padding: "10px",
              borderRadius: "5px",
              border: "1px solid #ccc",
            }}
          />




          {/* <Button
            color="white"
            bgColor={ (!isPreprocessingCompleted && !isPreprocessingStarted) ? currentColor  : 'gray' }
            text="전처리 및 시각화하기 "
            borderRadius="10px"
            onClick={() => {
              handleProgressBar();
            }}
          /> */}
          <button
            onClick={async () => {
              console.log("전처리 및 시각화 시작"); // 디버깅용 로그
            
              
              handleProgressBar();
              handleLambdaRequest(); // Lambda 호출 함수 실행
            }}
            style={{
              backgroundColor: currentColor,
              color: 'white',
              borderRadius: '10px',
              padding: '12px 24px',
              fontSize: '16px',
              cursor: 'pointer',
              border: 'none',
              transition: 'background-color 0.3s',
            }}
            className="hover:bg-gray-700 hover:drop-shadow-xl"
          >
            전처리 및 시각화하기
          </button>





          <Button
            color="white"
            bgColor={'rgb(215, 78, 114)'}
            text="전처리 초기화하기"
            disabled={!(isPreprocessingStarted || isPreprocessingCompleted)}
            borderRadius="10px"
            onClick={() => {
              handlePreprocessReset(); // 진행 바 관련 로직 실행
            }}
          />
        </div>
      </div>
      <br />

      <div className="bg-white p-8 rounded-3xl shadow-lg">
        <div className="flex items-center gap-3">
          <p className="text-xl font-semibold">전처리 진행률(%)</p>
          <div style={{
            width: '800px', marginLeft: '60px', marginRight: '20px',
            display: 'flex', alignItems: 'center'
          }}>

            <div style={{
              flex: 1, backgroundColor: '#e0e0e0',
              borderRadius: '8px', overflow: 'hidden'
            }}>
              <div
                style={{
                  width: `${progress}%`,
                  height: '20px',
                  backgroundColor: 'rgb(90, 198, 213)',
                  transition: 'width 0.5s ease-in-out',
                }}
              />
            </div>
            <span
              style={{
                marginLeft: '30px',
                marginRight: '10px',
                color: 'rgb(90, 198, 213)',
                fontWeight: 'bold',
              }}
            >
              {progress}%
            </span>
            {showSpinner && (
              <FontAwesomeIcon
                icon={faSpinner}
                spin
                size="lg"
                style={{ margin: '0 20px', color: 'rgb(90, 198, 213)' }}
              />
            )}
            <p className="text-s" style={{ marginRight: '20px', marginLeft: '20px', display: 'flex', alignItems: 'center' }}>{progressStatus}</p>

          </div>

        </div>
      </div>
      <br />
      <div className="flex justify-end">
        
         <S3FileRequest ref={S3FileRequestRef} />
      </div>
      

    </div>
  );
};

export default DataPreprocess;